"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Modal/index"), exports);
var index_1 = require("./components/Modal/index");
exports.default = index_1.Modal;
//# sourceMappingURL=Modal.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/Modal.js
// module id = ../node_modules/office-ui-fabric-react/lib/Modal.js
// module chunks = 1